import globalCache from './globalCache';
import workDaysAndTime from './workDaysAndTime';
import wbs from './wbs';
import cascadeSort from './cascadeSort';
import expandCollapse from './expandCollapse';
import customDuration from './customDuration';
import customTimeline from './customTimeline';
import exportToXML from './exportToXML';
import accessToTasks from './accessToTasks';
import createTask from './createTask';
import syncLinks from './syncLinks';
import moveProject from './moveProject';
import customDragndrop from './customDragndrop';

const Extensions = {
  init(instance) {
    globalCache(instance); // adds global cache to gantt instance
    createTask(instance); // adds custom task creation method to instance

    workDaysAndTime(instance); // adds to instance methods to work with work time and dates

    wbs(instance); // adds custom wbs code method to skip total estimate

    cascadeSort(instance); // adds cascade sorting
    expandCollapse(instance); // adds expand/collapse all to instance

    customDuration(instance); // adds custom duration calculation method to instance
    customTimeline(instance); // stretches task bars across the entire width of the timeline column in chart

    exportToXML(instance); // add custom exportToMSProject method to export XML
    accessToTasks(instance); // check access for tasks and fields

    syncLinks(instance); // adds $target and $source properties sync to instance
    moveProject(instance); // update start date property for project task
    customDragndrop(instance); // adds custom dragndrop methods to override the default dragndrop behavior
  },
};

export default Extensions;
